/**
 * Worklist-only: after submit/cancel, the app may auto-advance via loadNextOrPreviousCase → getPrevOrNextCase.
 * Cases → Amplify must not satisfy this (CDMX-15442).
 */
export function shouldAutoAdvanceWorklistAfterSubmit(
  cursorAPIPayload?: CMxCommonApp.CursorAPIPayload
): boolean {
  const ctx = cursorAPIPayload?.cursorAPIContext;
  if (ctx == null) {
    return false;
  }
  if (ctx.servicedeskMode !== true) {
    return false;
  }
  if (!ctx.workitemId) {
    return false;
  }
  const query = ctx.worklistContext?.query;
  if (query == null || typeof query !== 'object') {
    return false;
  }
  return true;
}
